import React, { useState, useEffect } from "react";
import { Button, Col, Row } from "antd";

const EmailTemplate = props => {
  const [showButton, setShowButton] = useState(false);

  const renderButton = () => {
    setTimeout(() => setShowButton(true), 4000);
  };

  useEffect(() => {
    renderButton();
  }, []);
  console.log(props.emailTools)
  return (
    <div className="emailer-tool">
      <Row>
        <Col style={{ marginTop: 10, marginBottom: 10 }}>
          {showButton ? (
            <div style={{ float: "right", marginRight: 20 }}>
              <Button
                style={{ marginRight: 20 }}
                type="primary"
                color="green"
                onClick={() => props.onCancel()}
              >
                Cancel
              </Button>
              <Button type="primary" color="green" onClick={props.saveTemplate}>
                Next
              </Button>
            </div>
          ) : null}
        </Col>
      </Row>
      {props.emailTools}
    </div>
  );
};

export default EmailTemplate;
